import { FC, ReactNode } from 'react'

import styled from 'styled-components'

import { CampaignStatusEnum } from 'src/Types/campaigns'
import { CampaignPaymentState } from 'src/Redux/artistOrderApi/campaignPayment'
import PlayIcon from 'src/Assets/Svg/campaign-statuses-icons/Play.svg?react'
import RunningIcon from 'src/Assets/Svg/campaign-statuses-icons/Running.svg?react'
import StopIcon from 'src/Assets/Svg/campaign-statuses-icons/Stop.svg?react'
import SuccessIcon from 'src/Assets/Svg/campaign-statuses-icons/Success.svg?react'
import TimeIcon from 'src/Assets/Svg/campaign-statuses-icons/Time.svg?react'

const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  color: ${({ theme }) => theme.color.darkGrey};
  text-overflow: ellipsis;
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`
export interface CampaignStatusProps {
  status: CampaignStatusEnum
  className?: string
  paymentState?: CampaignPaymentState | null
}

const STOPPED = 'Stopped'

const statusByIconMap: Partial<Record<CampaignStatusEnum, ReactNode>> = {
  [CampaignStatusEnum.APPROVED]: <PlayIcon />,
  [CampaignStatusEnum.PENDING]: <PlayIcon />,
  [CampaignStatusEnum.PENDING_APPROVAL]: <TimeIcon />,
  [CampaignStatusEnum.AWAITING_REVIEW]: <TimeIcon />,
  [CampaignStatusEnum.STOPPED]: <StopIcon />,
  [CampaignStatusEnum.ENDED]: <SuccessIcon />,
  [CampaignStatusEnum.RUNNING]: <RunningIcon />,
  [CampaignStatusEnum.INPROCESS]: <RunningIcon />,
  [CampaignStatusEnum.SCHEDULED]: <TimeIcon />,
  [CampaignStatusEnum.CANCELED_BY_ADMIN]: <StopIcon />,
  [CampaignStatusEnum.STOPPED_BY_ADMIN]: <StopIcon />,
}

const statusMap: Partial<Record<CampaignStatusEnum, string>> = {
  [CampaignStatusEnum.STOPPED]: STOPPED,
  [CampaignStatusEnum.ENDED]: 'Ended',
  [CampaignStatusEnum.RUNNING]: 'Running',
  [CampaignStatusEnum.INPROCESS]: 'Running',
  [CampaignStatusEnum.SCHEDULED]: 'Scheduled',
  [CampaignStatusEnum.APPROVED]: 'Approved to start',
  [CampaignStatusEnum.PENDING]: 'Approved to start',
  [CampaignStatusEnum.PENDING_APPROVAL]: 'Pending approval',
  [CampaignStatusEnum.AWAITING_REVIEW]: 'Pending approval',
  [CampaignStatusEnum.CANCELED_BY_ADMIN]: STOPPED,
  [CampaignStatusEnum.STOPPED_BY_ADMIN]: STOPPED,
}

export const CampaignStatus: FC<CampaignStatusProps> = (props) => {
  const { status, className, paymentState } = props
  if (paymentState === CampaignPaymentState.InProgress) {
    return (
      <Container className={className}>
        <TimeIcon />
        <span>Payment in progress</span>
      </Container>
    )
  }
  if (paymentState === CampaignPaymentState.Failed) {
    return (
      <Container className={className}>
        <StopIcon />
        <span>Payment failed</span>
      </Container>
    )
  }
  if (status in statusMap) {
    return (
      <Container className={className}>
        {statusByIconMap[status]}
        <span>{statusMap[status]}</span>
      </Container>
    )
  }
  return null
}
